import styled from '@emotion/styled'
import { typo } from '@mathflat/common/style'
import { s3URL } from '@mathflat/common/util'
import { observer } from 'mobx-react'
import React from 'react'
import type { Scenario } from 'src/dto'

import { _OldButton } from '@/component/atoms/Button/_OldButton'
import modalService from '@/service/modal.service'

const ScenarioCompletePopup = ({
  title,
  descHTML,
  ctaButton,
  onClick,
}: Scenario['완료팝업'] & { onClick?: () => void }) => {
  return (
    <S.ScenarioCompletePopup>
      <h5 className="title">{title}</h5>
      <div className="description" dangerouslySetInnerHTML={{ __html: descHTML }} />
      <_OldButton theme="primary" width={ctaButton.width} className="cta-button" onClick={onClick}>
        {ctaButton.text}
      </_OldButton>
      <button
        className="close"
        onClick={() => {
          modalService.closeModal()
        }}
      >
        닫기
      </button>
    </S.ScenarioCompletePopup>
  )
}

const S = {
  ScenarioCompletePopup: styled.div`
    position: relative;
    width: 494px;

    display: flex;
    flex-direction: column;
    align-items: center;

    background: no-repeat
      url(${s3URL.mathflatAssetsBucket.teacher('images/scenario/scenario_complete_bg.png')});
    background-size: 437px 116px;
    background-position: top center;
    padding: 24px;

    .title {
      ${typo.heading05};
      font-weight: 700;
    }
    .description {
      margin-top: 10px;
      text-align: center;
    }
    .cta-button {
      margin-top: 24px;
    }
    .close {
      position: absolute;
      bottom: -38px;
      right: 0;
      ${typo.body01};
      color: white;
    }
  `,
}
export default observer(ScenarioCompletePopup)
